import React, {useEffect} from 'react';
import {ControlGroup, FormGroup, NumericInput} from '@blueprintjs/core';

import {intervalValue} from '../utils';
import {OnChangeCallback} from './types';
import AdvancedOptions from './AdvancedOptions';

interface MinutelyProps {
  interval: any;
  byHour: number[] | string[];
  weekdays: string[];
  onChange: OnChangeCallback;
}

const _getMinutes = (value: number, min: number, max: number) => {
  /*
   * Minutes can be 10, 20, 30, 40, 50
   */
  if (value < min) {
    return min;
  } else if (value > max) {
    return max;
  } else if (value % 10 !== 0) {
    return min;
  }
  return value;
}

export const Minutely = ({
  interval,
  byHour,
  weekdays,
  onChange,
}: MinutelyProps) => {
  const MIN = 10;
  const MAX = 50;
  const defaultValue = _getMinutes(interval, MIN, MAX);

  useEffect(() => {
    if (defaultValue !== interval) {
      onChange('interval', intervalValue)(defaultValue);
    }
  }, []);

  return (
    <>
      <ControlGroup fill={true} className="no-flex">
        <FormGroup
          label="Every"
          inline={true}>
          <NumericInput
            className="minutely-interval"
            min={MIN}
            max={MAX}
            stepSize={5}
            defaultValue={defaultValue}
            /*buttonPosition={"none"}*/
            onValueChange={onChange('interval', intervalValue)}/>
        </FormGroup>
        <span className="info-text"> minute(s)</span>
      </ControlGroup>
      <AdvancedOptions
        byHour={byHour}
        weekdays={weekdays}
        onChange={onChange}
      />
    </>
  );
};
